import type { HealthDeps, HealthMonitor, HealthThresholds } from './api';
import { DEFAULT_HEALTH_THRESHOLDS } from './api';
import { createWorkerClock } from './clock';
import { createMonitor } from './monitor';
import { createBrowserPage } from './page';

export type * from './api';
export { DEFAULT_HEALTH_THRESHOLDS } from './api';
export { evaluateHealth, createHealthEngineState, WHIP_PEER_ID } from './rules';
export type {
  EvaluationContext,
  HealthEngineState,
  HealthEvaluation,
  RecoveryRequest,
  RecoveryResult,
} from './rules';

export function createHealthMonitor(deps: HealthDeps, thresholds?: Partial<HealthThresholds>): HealthMonitor {
  return createMonitor(deps, thresholds, DEFAULT_HEALTH_THRESHOLDS, {
    clock: createWorkerClock(),
    page: createBrowserPage(),
  });
}
